// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ChangePasswordPayload } from '@coa/app/libs/auth/auth-module/models/change-password-payload';

function checkPasswords(formGroup: FormGroup) {
  return formGroup.value.newPassword === formGroup.value.repeatNewPassword ? null : {notSame: true};
}

class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
    const invalid = (invalidCtrl || invalidParent);
    if (control) {
      return invalid && !!control.parent.errors && control.touched;
    }
    return invalid;
  }
}

@Component({
  selector: 'lib-auth-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  errorStateMatcher = new MyErrorStateMatcher();

  @Output() passwordChanged = new EventEmitter<ChangePasswordPayload>();

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      currentPassword: ['',
        [
          Validators.required,
        ],
      ],
      newPassword: ['',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*\\d).{0,}$'),
        ],
      ],
      repeatNewPassword: ['',
        [
          Validators.required,
        ],
      ],
    }, {validator: checkPasswords});
  }

  change(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }

    const payload = {
      currentPassword: this.form.value.currentPassword,
      newPassword: this.form.value.newPassword,
    };
    this.passwordChanged.emit(payload);
    this.form.reset();
  }
}
